<template>
  <div class="py-2 gap-2 flex">
    <div class="w-1/2 max-w-[120px]">
      <Button
        size="sm"
        variant="outline"
        class="w-full"
        @click="chatStore.openChat({ name: item.name, id: item.id, canReceiveSms: item.can_receive_sms })"
      >
        <vue-feather type="message-square" size="16" />
        Message
      </Button>
    </div>

    <div class="w-1/2 max-w-[120px]">
      <Button size="sm" variant="dark" class="w-full" @click="showScheduleMeeting = true">
        <vue-feather type="calendar" size="16" />
        Schedule
      </Button>
    </div>

    <ScheduleMeetingSheet
      v-if="showScheduleMeeting"
      :contact="scheduleMeetingContact"
      @close="showScheduleMeeting = false"
      @scheduled="
        showScheduleMeeting = false;
        refreshCandidates?.();
      "
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, inject } from 'vue';
import { Button } from '@/components/ui/button';
import type { CandidateEntity } from '@/api/entity_types/recruiting/Candidate';
import { useMultiChatStore } from '@/components/shared/MultiChat';
import ScheduleMeetingSheet from '@/components/contact/ScheduleMeetingSheet/index.vue';

const chatStore = useMultiChatStore();
const refreshCandidates = inject<() => void>('refreshCandidates');

const showScheduleMeeting = ref(false);

const { item } = defineProps<{
  item: CandidateEntity;
}>();

const scheduleMeetingContact = computed(() => ({
  id: item.id,
  name: item.name,
  firstName: item.first_name,
  lastName: item.last_name,
  email: item.email,
  phone: item.phone,
  stage: item.stage_name,
  canReceiveSms: item.can_receive_sms,
}));
</script>
